import {
  DateDropdownOption,
  DateDropdownOptionDay,
  DateDropdownOptionInLast,
  DateDropdownOptionMonth,
  DateDropdownOptionWeek,
  DateDropdownOptionYear,
  DateDropdownType,
} from "pages/shared/Dashboard/types";

export const getDefaultOptionInLastOption = (): DateDropdownOptionInLast => ({
  type: "inlast",
  value: "1w",
});

const getDefaultMonthOption = (): DateDropdownOptionMonth => ({
  type: "month",
  offset: 0,
});

const getDefaultWeekOption = (): DateDropdownOptionWeek => ({
  type: "week",
  offset: 0,
  hour: 17,
  cutoffDay: 6,
});

const getDefaultYearOption = (): DateDropdownOptionYear => ({
  type: "year",
  offset: 0,
});

const getDefaultDayOption = (): DateDropdownOptionDay => ({
  type: "day",
  offset: 1,
  hour: 17,
});

export const getDefaultOption = (
  type: DateDropdownType
): DateDropdownOption => {
  if (type === "inlast") {
    return getDefaultOptionInLastOption();
  } else if (type === "month") {
    return getDefaultMonthOption();
  } else if (type === "week") {
    return getDefaultWeekOption();
  } else if (type === "year") {
    return getDefaultYearOption();
  } else if (type === "day") {
    return getDefaultDayOption();
  }

  return getDefaultOptionInLastOption();
};

export const isDateDropdownOptionInLast = (
  option: DateDropdownOption
): option is DateDropdownOptionInLast => option.type === "inlast";

export const isDateDropdownOptionWeek = (
  option: DateDropdownOption
): option is DateDropdownOptionWeek => option.type === "week";

export const isDateDropdownOptionMonth = (
  option: DateDropdownOption
): option is DateDropdownOptionMonth => option.type === "month";

export const isDateDropdownOptionYear = (
  option: DateDropdownOption
): option is DateDropdownOptionYear => option.type === "year";

export const isDateDropdownOptionDay = (
  option: DateDropdownOption
): option is DateDropdownOptionDay => option.type === "day";
